export default __webpack_public_path__ + "static/media/react-logo-png_2224770.3ba04486.png";